import ApplicationController from './application_controller';

// Keeps discipline group headers (`.select-menu-group`) in sync with option visibility
// inside a `<ul class="select-menu">`. The auto-complete-element filters the list by
// toggling [hidden] on [role="option"] rows as the user types, but it never touches the
// non-option group headers — so without this they'd linger above an empty group. We watch
// the list for [hidden] changes and hide any header whose options are all hidden.
//
// Attach to the <ul> itself:
//   <ul class="select-menu" data-controller="select-menu-groups"> … </ul>
export default class extends ApplicationController {
  connect() {
    this.observerOptions = {
      attributes: true,
      attributeFilter: ['hidden'],
      subtree: true,
      childList: true,
    };
    this.observer = new MutationObserver(() => this.refresh());
    this.observer.observe(this.element, this.observerOptions);
    this.refresh();
  }

  disconnect() {
    this.observer?.disconnect();
    this.observer = undefined;
  }

  refresh() {
    // Disconnect while we mutate header [hidden] so our own writes don't re-trigger the observer.
    this.observer?.disconnect();

    let currentHeader = null;
    let groupHasVisibleOption = false;
    const commit = () => {
      if (currentHeader) currentHeader.hidden = !groupHasVisibleOption;
    };

    for (const el of this.element.children) {
      if (el.classList.contains('select-menu-group')) {
        commit();
        currentHeader = el;
        groupHasVisibleOption = false;
      } else if (el.getAttribute('role') === 'option' && !el.hidden) {
        groupHasVisibleOption = true;
      }
    }
    commit();

    this.observer?.observe(this.element, this.observerOptions);
  }
}
